import {useCallback, useEffect, useRef} from 'react';

export function useDebounce<T extends (...args: any[]) => any>(fn: T, delay: number): (...args: Parameters<T>) => void {
    const ref = useRef<number>();
    const fnRef = useRef<T>();

    useEffect(() => {
        fnRef.current = fn;
    });

    return useCallback((...args) => {
        if (ref.current) {
            clearTimeout(ref.current);
        }
        // @ts-ignore
        ref.current = setTimeout(() => {
            fnRef.current(...args);
            ref.current = null;
        }, delay);
    }, [delay]);
}
